<app-page-title
	title="Ranking"
	subtitle="Tabela Bolão Pé na Cova {{year}}"
	breadcrumb="Ranking {{year}}"
	[loading]="loading"
	/>

<div class="ranking-container">
	<app-ranking-list />
</div>



